/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".newDocumentCommandIcon_d9a71249{height:16px;width:16px}.newDocumentCommandIcon_d9a71249 img{line-height:normal;display:block}\n"}]);
export const newDocumentCommandIcon = "newDocumentCommandIcon_d9a71249";